jQuery(document).ready(function($){

    $('.course__form select').change(function() {
        $('.course__form').submit();
    });

});
